// extracted by mini-css-extract-plugin
export default {"root":"Header-root_ILLmJ","open":"Header-open_UeGbU","widgets":"Header-widgets_MF8cq"};